import { AfterViewInit, Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SubmitApplicationResultModel } from 'src/app/shared/models/application/submitApplicationResultModel';
import { CredentialDefinitionType } from 'src/app/shared/models/credential/credential-definition.model';
import { InvoiceModel } from 'src/shared-app-portal/components/profile-payments/invoice-model';
import { PaymentService } from 'src/shared-app-portal/services/payment.service';
import { AccessibilityService } from 'src/app/shared/services/accessibility.service';

//** min fields required to wire up the preview or application */
export type PreviewForm = { confirmationTitle: string; confirmation: string; id: string };

@Component({
  selector: 'app-application-confirmation',
  templateUrl: './application-confirmation.component.html',
  styleUrls: ['./application-confirmation.component.scss'],
  standalone: false
})
export class ApplicationConfirmationComponent implements OnInit, AfterViewInit {
  @Input()
  previewForm: PreviewForm;
  isAdded: boolean;
  confirmationMessageTitle: string;
  confirmationMessage: string;
  invoiceId: string;
  checkInstructions: string;
  invoice: InvoiceModel;
  personId: string;

  private readonly DEFAULT_CONFIRMATION_TITLE: string = 'We received your submission!';

  constructor(
    private paymentService: PaymentService,
    private accessibilityService: AccessibilityService,
    router: Router
  ) {
    const state = router.currentNavigation()?.extras?.state;
    if (!state) {
      return; //keep this in constructor. Moving to on-init then router.getCurrentNavigation() return null
    }

    const {
      invoiceId,
      personId,
      isAdded,
      confirmationTitle,
      confirmationMessage,
      checkInstructions,
      teamId
    } = state as SubmitApplicationResultModel & {
      checkInstructions: string;
      confirmationTitle: string;
      confirmationMessage: string;
    };
    if (teamId) {
      this.paymentService.initForTeam(teamId);
    } else {
      this.paymentService.initForPerson(personId);
    }
    this.isAdded = isAdded;
    this.checkInstructions = checkInstructions;
    this.confirmationMessageTitle = confirmationTitle;
    this.confirmationMessage = confirmationMessage;
    this.invoiceId = invoiceId;
    this.personId = personId;
  }

  ngOnInit() {
    this.onInit();
  }

  ngAfterViewInit() {
    //announce after this view has rendered. Screen readers rebuild their virtual buffer on a
    //route change, so a status message written before that completes is never spoken.
    this.accessibilityService.talk(
      this.confirmationMessageTitle ?? this.DEFAULT_CONFIRMATION_TITLE
    );
  }

  async onInit() {
    if (this.previewForm) {
      this.confirmationMessageTitle =
        this.previewForm.confirmationTitle ?? this.DEFAULT_CONFIRMATION_TITLE;
    }
    if (this.previewForm?.confirmation) {
      //form is in preview mode. No further work necessary
      this.confirmationMessage = this.previewForm.confirmation;
      return;
    }
    if (!this.invoiceId) {
      return;
    }
    if (this.personId) {
      this.invoice = await this.paymentService.getPaymentConfirmation(
        this.paymentService.isTeam
          ? CredentialDefinitionType.Team
          : CredentialDefinitionType.Person,
        this.invoiceId
      );
    } else {
      console.error(
        'expected personId to be set. Cannot set payment confirmation (if there was one)'
      );
    }
  }
}
